// AUTO-GENERATED by scripts/build-ad-manifest.mjs. Do not edit by hand.
// Regenerated by `npm run gen:ads` (also runs as predev / prebuild).

export const AD_VARIANTS: Readonly<Record<string, readonly string[]>> = {
  'banner': ['/ads/banner.png'],
  'infeed': ['/ads/infeed.png'],
  'rectangle': ['/ads/rectangle.png'],
  'responsive-desktop': ['/ads/responsive-desktop.png'],
  'responsive-mobile': ['/ads/responsive-mobile.png'],
} as const
